import React,{useRef,useState} from 'react';
import SideBar from './SideBar';
import GestCliente from './GestCliente';
import {BrowserRouter as Router,Switch,Route} from 'react-router-dom';
import GestContadores from './GestContadores';
import ComprarToken from './ComprarToken';
import '../home.css';
import TopBar from './TopBar';
import RegistarCliente from './RegistarCliente';
import GestVendas from './GestVendas';
import GestPagamentos from './GestPagamentos';
import GestRelatorios from './GestRelatorios';
import Profile from './Profile';
import PipeLine from './PipeLine';
import {Protegerotas} from './protegerotas';
import auth from './auth';
import { useHistory } from 'react-router-dom';
import IdleTimer from 'react-idle-timer';
import ComprasFeitas from './ComprasFeitas';
import type { MenuProps } from 'antd';
import { Breadcrumb, Layout, Menu, theme,Avatar } from 'antd';
import RollOver from './RollOver';
import FileUpload from './SuperUser';

import {
  ClockCircleOutlined,
  
  DesktopOutlined,
  PieChartOutlined,
  UserOutlined,

} from '@ant-design/icons';

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
): MenuItem {
  return {
    key,
    label,
    icon,
    children,
  };
}

function Home() {
  const ileTimeRed=useRef(null)
  const history = useHistory();
  const { Header, Content, Footer, Sider } = Layout;
  const [collapsed, setCollapsed] = useState(false);
  const [pagina,setPagina]=useState("home")
  const onIdle=()=>{
    localStorage.setItem('log',false)
    history.push('/');
  }
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  

  const handleClick = (e) => {
    console.log('Clicked: ', e.key);
    if(e.key =="1"){
      setPagina("Registar Cliente")
        history.push("/home/registar-cliente")
       
    }
    if(e.key=="21"){
      setPagina("Gestão de Clientes")
      history.push("/home/gest-cliente")

    }
    if(e.key=="22"){
      setPagina("Gestão de Contadores")
      history.push("/home/gest-contadores")

    }


    if(e.key=="23"){
      setPagina("PipeLine")
      history.push("/home/Pipeline")

    }
    
    if(e.key=="24"){
      setPagina("Compras")
      history.push("/home/compras")

    }
    if(e.key=="50"){
      setPagina("TID ROLLOVER")
      history.push("/home/rollover")

    }


  
  
  



  }

  const items: MenuItem[] = [
    getItem('Registar Cliente', '1', <DesktopOutlined />,  ),
    
    
    getItem('Gestao de Clientes', '21', <PieChartOutlined />),
    getItem('Gestao de Compras', '24', <ClockCircleOutlined />,  ),
    
    getItem('Gestao de Contadores', '22', <PieChartOutlined />),
    getItem('Pipeline', '23', <PieChartOutlined />),
    getItem('TID ROLLOVER', '50', <ClockCircleOutlined />),
 
   
    
  
  
  ];

    return (
     
<Layout >
<Sider theme="light" collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
<img  className="enh-kogas-logo" src={require('./images/ENH.png')}  />
<div style={{ height: 32, margin: 16, background: 'rgba(255, 255, 255, 0.2)' }} />

  <Menu theme="light"   onClick={handleClick}  defaultSelectedKeys={['1']} mode="inline" items={items} />
</Sider>
<Layout>
  <Header style={{ padding: 0, background: colorBgContainer }} >
    <div className='info_log'>
    <Avatar style={{ backgroundColor: '#87d068' }} icon={<UserOutlined />} />
  <label size={30}>.{ localStorage.getItem('username')}</label>
  

    </div>
  
  </Header>
  
  <Content    >
   
     
  <div
            style={{
              marginLeft:'0.5%',
              marginTop:'1%',
              padding: 24,
              minHeight: 360,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >          
          <IdleTimer ref={ileTimeRed} timeout={60*1000} onIdle={onIdle}></IdleTimer>
          <div className='content' >
         
          <Switch>
            
           {/*<Protegerotas path="/home/Comprar-Token" exact component={ComprarToken} /> */} 
            <Protegerotas path="/home/gest-contadores" component={GestContadores}/>
            <Protegerotas path="/home/gest-cliente" exact component={GestCliente}/>
            <Protegerotas path="/home/registar-cliente" exact component={RegistarCliente}/>
            <Protegerotas path="/home/gestvendas" exact component={GestVendas}/>
            <Protegerotas path="/home/gestpagamentos" exact component={GestPagamentos}/>
            <Protegerotas path="/home/gestrelatorios" exact component={GestRelatorios}/>
            <Protegerotas path="/home/Perfil" exact component={Profile}/>
            <Protegerotas path="/home/Pipeline" exact component={PipeLine}/>
            <Protegerotas path="/home/compras" exact component={ComprasFeitas} />
            <Protegerotas path="/home/rollover" exact component={RollOver} />
                             
          </Switch>
      
          </div>
          
          </div>
    
   
 
    

  </Content>
 
</Layout>
</Layout>
  
    
    )
}
export default Home
